/*
 * Tapping a collection or page in the menu shows a loading screen straight
 * away: the page title where the real headline will be, and a spinner where
 * the cards will appear, so the tap feels answered and nothing shifts when the
 * next page arrives. It goes away by itself when the new page loads.
 */
(function () {
  if (window.__sbfaNavLoading) return;
  window.__sbfaNavLoading = true;

  let overlay = null;
  let timer = null;

  function hide() {
    clearTimeout(timer);
    if (overlay) overlay.remove();
    overlay = null;
  }

  // Where each kind of page puts its headline and its first cards, measured on the
  // live theme. Distances are from the bottom of the header, so the headline does not
  // move when the real page arrives and the spinner sits where the cards will appear.
  function layoutFor(url) {
    const wide = window.matchMedia('(min-width: 750px)').matches;
    const path = url.pathname;

    if (path === '/pages/artists') {
      return { tag: 'h1', cls: 'title h1', title: wide ? 86 : 57, spinner: wide ? 198 : 146 };
    }
    if (path.indexOf('/pages/') === 0) {
      return { tag: 'h1', cls: 'main-page-title page-title h0', title: wide ? 28 : 21, spinner: wide ? 156 : 115 };
    }
    const cards = path === '/collections/all-artwork' ? (wide ? 127 : 106) : wide ? 107 : 86;
    return { tag: 'h2', cls: 'h2', title: wide ? 12 : 9, spinner: cards + 60 };
  }

  function show(title, url) {
    hide();
    const layout = layoutFor(url || new URL(window.location.href));

    overlay = document.createElement('div');
    overlay.className = 'nav-loading';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-label', 'Loading');

    const heading = document.createElement(layout.tag);
    heading.className = layout.cls + ' nav-loading__title';
    heading.textContent = title;
    heading.style.top = layout.title + 'px';

    const spinner = document.createElement('span'); // a span: the theme hides every empty div
    spinner.className = 'nav-loading__spinner';
    spinner.style.top = layout.spinner + 'px';

    overlay.append(heading, spinner);

    const header = document.querySelector('.header-wrapper');
    overlay.style.top = (header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0) + 'px';
    document.body.appendChild(overlay);

    // Never leave the screen up if the page doesn't arrive.
    timer = setTimeout(hide, 15000);
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || !link.closest('.header-wrapper')) return;
    if ((link.target && link.target !== '_self') || link.hasAttribute('download')) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    if (!/^\/(collections|pages)(\/|$)/.test(url.pathname)) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;

    show((link.textContent || '').replace(/\s+/g, ' ').trim(), url);
  });

  // Other scripts (the collection grid, while it rebuilds after a back) can use the same screen.
  window.sbfaLoadingScreen = { show, hide };

  // A page the browser kept in memory and brought back must not show a stale loading screen.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hide();
  });
})();
